import { render, staticRenderFns } from "./Header.vue?vue&type=template&id=61dd7a3d&scoped=true&"
import script from "./Header.vue?vue&type=script&lang=js&"
export * from "./Header.vue?vue&type=script&lang=js&"
import style0 from "./Header.vue?vue&type=style&index=0&id=61dd7a3d&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61dd7a3d",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/hanzhu/nutstore-webpages/js_src_vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('61dd7a3d')) {
      api.createRecord('61dd7a3d', component.options)
    } else {
      api.reload('61dd7a3d', component.options)
    }
    module.hot.accept("./Header.vue?vue&type=template&id=61dd7a3d&scoped=true&", function () {
      api.rerender('61dd7a3d', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Header.vue"
export default component.exports